import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class TeammateRepositoryService extends BaseRepositoryService<
  ModelRegistry['teammate'],
  ModelRegistry['teammate']
> {
  recordName = 'teammate';
  implementMethods = ['findAll', 'findRecord', 'unloadAll'];

  public async fetchTeammateById(
    id: string,
  ): Promise<ModelRegistry['teammate']> {
    const cache = this.getDataFromCache(id);

    if (cache) {
      return cache;
    }

    const teammate = await this.findRecord(id, {
      reload: true,
      include: 'permissions,permissions.parent',
    });

    this.cache[id] = teammate;

    return teammate;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/teammate': TeammateRepositoryService;
  }
}
